import { getStatementListRequest } from 'api/statement-list-api';
import { createAction } from 'redux-actions';
export const statementListLoading = createAction('STATEMENT_LIST_LOADING');
export const statementListLoaded = createAction('STATEMENT_LIST_LOADED');
export const statementListError = createAction('STATEMENT_LIST_ERROR');

export const requestGetStatementList =
  ({ withLoading = true, contextKey } = { withLoading: true }) =>
  async (dispatch, getState) => {
    if (withLoading) {
      dispatch(statementListLoading());
    }
    try {
      const stateData = getState().data;
      const selectedProject = stateData.selectedProject.project;
      const { sort, selectedTab } =
        stateData.statementList.statementListFilters;
      const isAuditClient = selectedProject.data.isAuditClient;
      const response =
        selectedProject && selectedProject.id
          ? await getStatementListRequest({
              status: selectedTab.apiParam,
              projectId: selectedProject.id,
              sort: sort.key,
              order: sort.order,
              //first and size are going to let us get an specific amount of statements, pagination.
              first: 0,
              // temporarily we are going to set the max amount of statements as 1000
              size: 1000,
              isAuditClient,
              contextKey,
              selectedProject,
            })
          : { data: { result: { elements: [] } } };

      dispatch(statementListLoaded({ response }));
    } catch (error) {
      dispatch(statementListError(error));
    }
  };
